
import React from 'react';
import { TouchableOpacity, Text, StyleSheet, TouchableOpacityProps } from 'react-native';
import { useThemeColor } from '@/hooks/useThemeColor';

interface SecondaryButtonProps extends TouchableOpacityProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
}

export default function SecondaryButton({ title, onPress, disabled = false, style, ...props }: SecondaryButtonProps) {
  const borderColor = useThemeColor({}, 'border');
  const borderDisabledColor = useThemeColor({}, 'borderDisabled');
  const primaryColor = useThemeColor({}, 'primary');
  const neutral400Color = useThemeColor({}, 'neutral400');

  return (
    <TouchableOpacity 
      style={[
        styles.button,
        { 
          borderColor: disabled ? borderDisabledColor : borderColor,
          opacity: disabled ? 0.6 : 1
        },
        style
      ]} 
      onPress={onPress}
      disabled={disabled}
      {...props}
    >
      <Text style={[
        styles.buttonText,
        { color: disabled ? neutral400Color : primaryColor }
      ]}>
        {title}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    borderWidth: 1,
    borderRadius: 16,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    height: 56,
    width: '100%',
    backgroundColor: 'transparent',
  },
  buttonText: {
    fontSize: 14,
    fontFamily: 'Inter_500Medium',
    lineHeight: 20,
    textAlign: 'center',
    fontWeight: '500',
  },
});
